export class RateScheduleEdit extends HTMLElement {
  constructor(data, group_id) {
    super();
    this.data = data
    this.group_id = group_id
  }

  async init() {
    this.rate_schedule_data = await this.fetchRateScheduleData(this.data.rate_schedule_id)
  }

  async fetchRateScheduleData(rate_schedule_id){
    let res = await fetch(`/admin/rate_schedules/${rate_schedule_id}/rate_schedule_charges`);
    let json = await res.json();
    console.log('[RateScheduleEdit] ' + JSON.stringify(json))
    return json;
  }
    
  connectedCallback() {
    let rate_schedule_charges = this.rate_schedule_data.data.map(role => `<div class='badge badge-pill badge-info'>${role.billing_charge_description} <span class="fas fa-times remove-industry" data-id="${role.rate_schedule_charge_id}"></span></div>`).join('')
    this.innerHTML = 
    `<style>
      #edit-user-back {
        font-family: "FontAwesome";
        font-weight: normal;
      }

      #edit-user-back:hover {
        cursor: pointer;
      }

      #edit-group-user {
        width: 75%;
        margin: 0 auto;
      }

      .edit-user-pills {
        margin-bottom: 5px;
      }

      group-user-edit h5 {
        margin-bottom: 20px;
      }
      
      .edit-user-buttons {
        margin-top: 20px;
      }

      .edit-user-div {
        margin: 20px 0;
      }

      group-user-edit .badge {
        margin: 3px 5px 3px 0;
      }

      group-user-edit .fas {
        font-family: FontAwesome;
      }

      group-user-edit .fa-times:hover {
        cursor: pointer;
      }

      group-user-edit h4 {
        font-weight: 600;
      }
    </style>
    <div class="" id="edit-group-user">
      <h3><span id="edit-user-back" class="fas fa-chevron-left"></span> Edit Rate Schedule2</h3>
      <div class="">
        <h4>Rate Schedule: ${this.data.name} (${this.data.rate_schedule_id})</h4>
        <div class="edit-user-div edit-user-role">
          <h4>Current Roles</h4>
          <div class="edit-user-pills">
            ${rate_schedule_charges}
          </div>
          <select is="group-role-select" id="edit-role-select" class="form-control"></select>
        </div>



        <div class="edit-user-buttons">
          <button type="button" class="btn btn-primary save pull-right detail-row-button" data-cy="save-user-edit">Save</button>
          <button type="button" class="btn btn-outline-secondary cancel pull-right detail-row-button">Cancel</button>
        </div>
      </div>
    </div>`;

    this.querySelector('#edit-user-back').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))
    
    this.querySelector('.cancel').addEventListener('click', function() {
      this.cancelEdit();
    }.bind(this))

    this.querySelector('.save').addEventListener('click', function() {
      this.save();
    }.bind(this))

    this.querySelector('#edit-role-select').onchange = (e) => {this.addRole(e.target, e.target.value)}

    this.querySelector('#edit-team-select').onchange = (e) => {this.addTeam(e.target, e.target.value)}

    this.querySelectorAll('.remove-user-role').forEach(button => {
      button.addEventListener('click', function(e) {
        this.removeRole(e.target.dataset.id)
      }.bind(this));
    })

    this.querySelectorAll('.remove-user-team').forEach(button => {
      button.addEventListener('click', function(e) {
        this.removeTeam(e.target.dataset.id)
      }.bind(this));
    })
  }

  cancelEdit() {
    this.remove();
    document.querySelector('group-users').show();
  }

  addRole(target, id) {
    let roleID = parseInt(id);
    if(roleID && !this.roles.some(e => e.group_role_name_id == roleID)) {
      this.roles.push({group_role_name: target.getCurrentName(),group_role_display_name: target.options[target.selectedIndex].text, group_role_name_id: roleID});
      this.new_roles = this.new_roles.filter(role => role.role_id != roleID)
      if(!this.current_role_ids.includes(roleID)) {
        this.new_roles.push({role_id: roleID, action: "ADD"})
      }
      this.connectedCallback();
    }
  }

  addTeam(name, id) {
    let teamID = parseInt(id);
    if(teamID && !this.teams.some(e => e.team_id == teamID)) {
      this.teams.push({name: name.options[name.selectedIndex].text, team_id: teamID, group_id: this.group_id});
      this.new_teams = this.new_teams.filter(team => team.team_id != teamID)
      if(!this.current_team_ids.includes(teamID)) {
        this.new_teams.push({team_id: teamID, action: "ADD"});
      }
      this.connectedCallback();
    }
  }

  removeRole(id) {
    if(this.roles.length === 1) {
      Common.notify('User must have a role.', 'danger')
      return
    }
    let roleID = parseInt(id);
    this.roles = this.roles.filter(role => role.group_role_name_id != roleID);
    this.new_roles = this.new_roles.filter(role => role.role_id != roleID);
    if(this.current_role_ids.includes(roleID)) {
      this.new_roles.push({role_id: roleID, action: "DELETE"})
    }
    this.connectedCallback();
  }

  removeTeam(id) {
    let teamID = parseInt(id);
    this.teams = this.teams.filter(team => team.team_id != teamID);
    this.new_teams = this.new_teams.filter(team => team.team_id != teamID);
    if(this.current_team_ids.includes(teamID)) {
      this.new_teams.push({team_id: teamID, action: "DELETE"})
    }
    this.connectedCallback();
  }

  async save() {
    let userID = this.user_profile.user_id;
    let data = {user: this.data.id, auto_group_id: this.group_id, new_roles: this.new_roles, new_teams: this.new_teams};

    if(this.roles.filter(role => role.group_role_name == "messaging_agent").length > 0 && this.querySelectorAll('.edit-user-team .edit-user-pills .badge').length <= 0) {
      Common.notify('User must have a Team.', 'danger')
      return;
    }

    let result = await fetch(`/admin/users/${userID}/update_roles`, {
      method: 'PUT',
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    if(result.ok) {
      Common.notify('User roles updated', 'success');
      this.cancelEdit();
      document.querySelector('group-users').reloadData();
    }
    else Common.notify('Failed to update user', 'error');
  }
}

customElements.define('rate-schedule-edit', RateScheduleEdit)